import React from 'react';
import { StyledDivider } from './styled';

export const Divider = ({ margin, topBorder = true, ...props }) => {
    return <StyledDivider $margin={margin} $topBorder={topBorder} {...props} />;
};
